module.exports = __webpack_public_path__ + "static/media/logo_novabank_footer.4b90ec2f.svg";